import { render, staticRenderFns } from "./Directors.vue?vue&type=template&id=6b981c2f&scoped=true&"
import script from "./Directors.vue?vue&type=script&lang=js&"
export * from "./Directors.vue?vue&type=script&lang=js&"
import style0 from "./Directors.vue?vue&type=style&index=0&id=6b981c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b981c2f",
  null
  
)

export default component.exports